import { Alert, Button, type ButtonProps, Text } from "@mantine/core";
import type { FormEvent, PropsWithChildren, ReactNode } from "react";

export interface CommonAuthFormProps {
  errorMessage?: string;
  onSubmit: (event: FormEvent) => void;
}

interface AuthFormContainerProps
  extends PropsWithChildren,
    CommonAuthFormProps {
  bottomContent?: ReactNode;
  submitButtonContent: ReactNode;
  submitButtonProps?: Partial<ButtonProps>;
  subTitle?: string;
  title: string;
}

export const AuthFormContainer = ({
  bottomContent,
  children,
  errorMessage,
  onSubmit,
  submitButtonContent,
  submitButtonProps = {},
  subTitle,
  title,
}: AuthFormContainerProps) => {
  return (
    <>
      <Text size="lg" fw={600}>
        {title}
      </Text>
      {subTitle && (
        <Text c="gray.7" mt="30px" ta="center">
          {subTitle}
        </Text>
      )}
      <form
        className="flex flex-col items-center justify-center mt-[30px] w-full"
        onSubmit={onSubmit}
      >
        {children}
        {errorMessage && (
          <Alert
            className="text-center w-full"
            color="red"
            radius="md"
            variant="light"
          >
            {errorMessage}
          </Alert>
        )}
        <Button
          className="mt-4 my-2"
          color="mint-green.8"
          fullWidth
          size="md"
          type="submit"
          variant="filled"
          {...submitButtonProps}
        >
          {submitButtonContent}
        </Button>
        <div className="mt-5">{bottomContent}</div>
      </form>
    </>
  );
};
